import { Container, Heading, Stack } from "@chakra-ui/react";
import { OverviewChart } from "../components/OverviewChart";
import { Summary } from "../components/Summary";
import { TransactionList } from "../components/TransactionList";
import { ExpenseLimitsProgress } from "../components/ExpenseLimitsProgress";
import { SavingGoalsProgress } from "../components/SavingGoalsProgress";

export default function Overview() {
  return (
    <Container maxW="lg" py={10} pb={{ base: 24, md: 10 }}>
      <Stack spaceY={6}>
        <Heading textAlign="center">Übersicht</Heading>
        <Summary />
        <SavingGoalsProgress />
        <ExpenseLimitsProgress />
        <OverviewChart />
        <TransactionList />
      </Stack>
    </Container>
  );
}
